module.exports = __webpack_public_path__ + "img/consultation.00293d7e.png";